import { Navigate } from "react-router-dom";
import Login from "../auth/Login";
import ResetPassword from "../auth/ResetPassword";
import VerifyEmail from "../auth/VerifyEmail";
import CreatePassword from "../auth/CreatePassword";
import ProtectLoginRoute from "./ProtectLoginRoute";
import PrivateRoute from "./PrivateRoute";
import Profile from "../pages/Profile";
import Dashboard from "../pages/Dashboard";
import UserManagement from "../pages/UserManagement";
import ActivityManagement from "../pages/ActivityManagement";
import EventManagement from "../pages/EventManagement";
import EditEvent from "../components/EventManagement/EditEvent";
import NotificationManagement from "../pages/NotificationManagement";
import FeedbackSupport from "../pages/FeedbackSupport";
import DeleteAccount from "../pages/DeleteAccount";
import PrivacyPolicyAdmin from "../pages/PrivacyPolicyAdmin";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import Csae from "../pages/Csae";
import ActivityImages from "../pages/ActivityImages";
import MarketplaceManagement from "../pages/MarketplaceManagement";
import EventDetails from "../pages/EventDetails";
import AppVersion from "../components/AppVersion/AppVersion";

const routes = [
  {
    path: "/",
    element: (
      <ProtectLoginRoute>
        <Login />
      </ProtectLoginRoute>
    ),
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },
  {
    path: "/create-password",
    element: <CreatePassword />,
  },
  {
    path: "/profile",
    element: (
      <PrivateRoute>
        <Profile />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },
  {
    path: "/activity-management",
    element: <ActivityManagement />,
  },
  {
    path: "/activity-images",
    element: <ActivityImages />,
  },
  {
    path: "/marketplace-management",
    element: <MarketplaceManagement />,
  },
  {
    path: "/event-details",
    element: <EventDetails />,
  },
  {
    path: "/category-management",
    element: <EventManagement />,
  },
//   {
//     path: "/event-management/edit",
//     element: <EditEvent />,
//   },
  {
    path: "/notification-management",
    element: <NotificationManagement />,
  },
  {
    path: "/feedback-support",
    element: <FeedbackSupport />,
  },
  {
    path: "/privacy-policy-admin",
    element: <PrivacyPolicyAdmin />,
  },
  {
    path: "delete-account",
    element: <DeleteAccount />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/csae",
    element: <Csae />,
  },
  {
    path: "/app-version",
    element: <AppVersion />,
  },
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];
export default routes;
